import { VpcService } from '@inter-ikea-kompis/core/services'
import type { IDexfSettings } from '@inter-ikea-kompis/core/types'

import { customEvents } from '@/integrations/insights/custom-events'
import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'
import { redirectHome } from '@/utils/redirects'

import type { InsightsApi } from '@insights/insights-data-provider'

export async function getConfigurationFromDesignCodeOrRedirectHome(
  dexfSettings: IDexfSettings,
  designCode: string,
  insightsApi?: InsightsApi | null,
) {
  const vpcService = new VpcService({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    settings: dexfSettings,
  })

  try {
    const configuration = await vpcService.getConfiguration(designCode)

    if (!configuration) throw redirectHome('/$country/$language/$mode/design/$code')

    void insightsApi?.sendEvent({
      category: customEvents.open_vpc_code,
      event: 'open_vpc_code',
      payload: { designCode },
    })

    return configuration
  } catch (_error) {
    throw redirectHome('/$country/$language/$mode/design/$code')
  }
}
